import registry from "./registry.json";

// UI-only contract. Backend owns help/permission metadata; the backend freshness
// test verifies this complete projection against its registry and real App routes.

export const AI_PAGES = Object.fromEntries(registry.pages.map((page) => [page.id, page]));
const validId = (value) => typeof value === "string" && /^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/.test(value);

export function boundedPageContext(value) {
  if (!value || value.version !== 1) return null;
  const page = AI_PAGES[value.page_id];
  if (!page) return null;
  const result = { version: 1, page_id: page.id };
  if (value.entity_public_id || value.entity_type) {
    if (value.entity_type !== page.entity_type || !validId(value.entity_public_id)) return null;
    result.entity_type = value.entity_type;
    result.entity_public_id = value.entity_public_id;
  } else if (page.entity_required) return null;
  if (value.section) {
    if (!page.sections.includes(value.section)) return null;
    result.section = value.section;
  }
  if (value.focused_action_id) {
    if (!page.actions.includes(value.focused_action_id)) return null;
    result.focused_action_id = value.focused_action_id;
  }
  return result;
}

export function pageContextForPath(pathname) {
  for (const page of registry.pages) {
    if (!page.navigable) continue;
    const parts = page.route.split(":id");
    if (parts.length === 1 && pathname === page.route) return { version: 1, page_id: page.id };
    if (parts.length === 2 && pathname.startsWith(parts[0])) {
      const id = pathname.slice(parts[0].length);
      if (validId(id)) return boundedPageContext({ version: 1, page_id: page.id, entity_type: page.entity_type, entity_public_id: id });
    }
  }
  return null;
}

export function resolveAINavigation(action) {
  if (!action || action.type !== "navigate" || Object.keys(action).some((key) => !["type", "destination_id", "entity_public_id"].includes(key))) return null;
  const page = AI_PAGES[action.destination_id];
  if (!page?.navigable) return null;
  if (page.route.includes(":id")) return validId(action.entity_public_id) ? page.route.replace(":id", encodeURIComponent(action.entity_public_id)) : null;
  return action.entity_public_id ? null : page.route;
}
